import DatePicker from "component/element/DatePicker";
import React, { Component } from "react";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  Modal,
  Row,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import { Checkbox } from "react-icheck";
import { connect } from "react-redux";
import Select from "react-select";
import { Box } from "reactjs-admin-lte";
import HrStore from "stores/HrStore";

var NotificationSystem = require("react-notification-system");
class ReportSSOPage extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      loading: true,
      data: [],
      doc: {},
      showEmp: false,
      emp_select: [],
      sumSSO_amount: 0,
      branchList: [],
      departmentList: [],
      branchSelect: [],
      departmentSelect: [],
    };
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData();
    this.loadSsoConfig();
  }

  loadData() {
    this.setState({ loading: true });
    HrStore.loadSSOList((result) => {
      let data = result.data.itemlist.map((item, index) => {
        item = Object.assign({ isCheck: true }, item);
        item.actual_work = this.getNumberFormat(item.actual_work);
        return item;
      });
      this.setState({ loading: false, data: data, doc: result.data.doc });
    });
  }

  loadEmployeeSSO(completeFunc = undefined) {
    let { emp_select } = this.state;
    this.setState({ loading: true });
    HrStore.loadEmployeeSSO(
      emp_select.join(),
      (result) => {
        let data = result.data.map((item, index) => {
          item = Object.assign({ isCheck: true }, item);
          item.actual_work = this.getNumberFormat(item.actual_work);
          return item;
        });
        this.setState({ loading: false, data: data }, () => {
          if (completeFunc !== undefined) completeFunc();
        });
      },
      this.state.branchSelect,
      this.state.departmentSelect
    );
  }

  loadSsoConfig() {
    this.setState({ loading: true });
    HrStore.loadSsoConfig((result) => {
      this.setState({
        branchList: result.data.branch_list,
        departmentList: result.data.department_list,
      });
    });
  }

  getYearOptions() {
    let options = [];
    var dt = new Date();
    for (let i = dt.getFullYear() * 1 + 543; i >= 2558; i--) {
      options.push({ label: i, value: i });
    }
    return options;
  }

  getMonthOptions() {
    let { messages } = this.props;
    return [
      { label: messages["January"], value: "01" },
      { label: messages["February"], value: "02" },
      { label: messages["March"], value: "03" },
      { label: messages["April"], value: "04" },
      { label: messages["May"], value: "05" },
      { label: messages["June"], value: "06" },
      { label: messages["July"], value: "07" },
      { label: messages["August"], value: "08" },
      { label: messages["September"], value: "09" },
      { label: messages["October"], value: "10" },
      { label: messages["November"], value: "11" },
      { label: messages["December"], value: "12" },
    ];
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  onFormChange(field, e) {
    let { doc } = this.state;
    doc[field] = e.target.value;
    this.setState({ doc: doc });
  }

  onPeriodicChange(field, e) {
    let { doc } = this.state;
    doc[field] = e.value;
    this.setState({ doc: doc });
  }

  onPaymentDateChange(e) {
    let { doc } = this.state;
    doc["payment_date"] = e;
    this.setState({ doc: doc });
  }

  sumSSO() {
    let { data } = this.state;
    var sumSSO_amount = 0;
    data.forEach((item) => {
      if (item.isCheck) {
        sumSSO_amount += parseInt(item.sso_amount, 10);
      }
    });
    this.setState({ sumSSO_amount: sumSSO_amount });
  }

  onCheckChange(val, index) {
    let { data } = this.state;
    data[index].isCheck = val;

    this.setState({ data: data });
    this.sumSSO();
  }

  onTextChange(field, index, e) {
    let { data, doc } = this.state;
    data[index][field] = e.target.value;
    if (field === "wage") {
      let wage =
        data[index][field] * 1 > doc.max_sso_wage * 1
          ? doc.max_sso_wage
          : data[index][field] * 1 < doc.min_sso_wage * 1
          ? doc.min_sso_wage
          : data[index][field];
      let sso_amount = wage * doc.sso_ratio;
      data[index]["actual_work"] = this.getNumberFormat(
        wage / data[index]["salary"]
      );
      data[index]["sso_amount"] = sso_amount / 100;
    } else if (field === "actual_work") {
      let wage = data[index][field] * data[index]["salary"];
      wage =
        wage * 1 > doc.max_sso_wage * 1
          ? doc.max_sso_wage
          : wage * 1 < doc.min_sso_wage * 1
          ? doc.min_sso_wage
          : wage;
      let sso_amount = wage * doc.sso_ratio;
      data[index]["sso_amount"] = sso_amount / 100;
    }
    this.setState({ data: data });
  }

  onEmpOpen() {
    this.setState({ showEmp: true });
  }

  onEmpHide() {
    this.setState({ showEmp: false, emp_select: [] });
  }

  onEmpSelect() {
    let { emp_select } = this.state;
    if (emp_select.length === 0) {
      this._notificationSystem.addNotification({
        title: "แจ้งเตือน",
        message: "กรุณาเลือกรายการก่อนดำเนินการต่อไป",
        level: "error",
        position: "tc",
      });
      return false;
    }
    this.loadEmployeeSSO(() => {
      this.sumSSO();
      this.onEmpHide();
    });
  }

  onEmpCheck(val) {
    let { emp_select } = this.state;
    if (emp_select.indexOf(val) === -1) {
      emp_select.push(val);
    } else {
      emp_select.splice(emp_select.indexOf(val), 1);
    }
    this.setState({ emp_select: emp_select });
  }

  onBranchCheck(val) {
    let { branchSelect } = this.state;
    if (branchSelect.indexOf(val) === -1) {
      branchSelect.push(val);
    } else {
      branchSelect.splice(branchSelect.indexOf(val), 1);
    }
    this.setState({ branchSelect: branchSelect });
  }

  onDepartmentCheck(val) {
    let { departmentSelect } = this.state;
    if (departmentSelect.indexOf(val) === -1) {
      departmentSelect.push(val);
    } else {
      departmentSelect.splice(departmentSelect.indexOf(val), 1);
    }
    this.setState({ departmentSelect: departmentSelect });
  }

  onLoadEmStatusOptions() {
    let { messages } = this.props;
    return [
      { value: "work", label: messages["All Active"] },
      { value: "0", label: messages["Full Time"] },
      { value: "1", label: messages["Sub Contract Monthly"] },
      { value: "2", label: messages["Sub Contract Daily"] },
      { value: "7", label: messages["Intern"] },
      { value: "8", label: messages["Contractor"] },
      { value: "3", label: messages["Exit"] },
      { value: "4", label: messages["Not Qualified"] },
      { value: "5", label: messages["Disappear"] },
      { value: "6", label: messages["Die"] },
    ];
  }

  padDigits = (number, digits) => {
    return (
      Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
    );
  };

  decimalToInteger = (number) => {
    let integer = parseFloat(number);
    integer = integer.toFixed(2);
    integer = integer * 100;
    return integer;
  };

  downloadTxtFile = (dataCount) => {
    let { data, doc, sumSSO_amount } = this.state;
    let cut_paydate;
    let payment_date = doc.payment_date.replace(
      /[&\/\\#,+()$~%.'":*?<>{}]/g,
      ""
    );
    cut_paydate = payment_date.substring(0, 4);
    let cut_year = doc.periodic_year.substring(2, 4);
    if (doc.company_name.length < 45) {
      doc.company_name += " ".repeat(45 - doc.company_name.length);
    } else {
      doc.company_name.substring(0, 45);
    }
    let text_body = "";
    var sum_wage = 0;
    var sum_sso = 0;
    data.forEach((item) => {
      sum_wage += parseInt(item.wage, 10);
      sum_sso += parseInt(item.sso_amount, 10);
      if (item.isCheck) {
        if (item.title === "นาย") {
          item.title = "003";
        } else if (item.title === "นางสาว") {
          item.title = "004";
        } else {
          item.title = "005";
        }
        if (item.first_name.length < 30) {
          item.first_name += " ".repeat(30 - item.first_name.length);
        } else {
          item.first_name.substring(0, 30);
        }
        if (item.last_name.length < 35) {
          item.last_name += " ".repeat(35 - item.last_name.length);
        } else {
          item.last_name.substring(0, 35);
        }

        text_body +=
          "2" +
          item.employee_tax_no +
          item.title +
          item.first_name +
          item.last_name +
          doc.company_branch +
          this.padDigits(this.decimalToInteger(item.salary), 14) +
          this.padDigits(this.decimalToInteger(item.sso_amount), 12);
        text_body += "\r\n";
      }
    });

    let text_head =
      "9" +
      doc.account_no +
      doc.company_branch +
      cut_paydate +
      payment_date.substring(6, 8) +
      doc.periodic_month +
      cut_year +
      doc.company_name +
      this.padDigits(doc.sso_ratio, 2) +
      this.padDigits(dataCount, 8) +
      this.padDigits(this.decimalToInteger(sum_wage), 15) +
      this.padDigits(this.decimalToInteger(sum_sso), 14) +
      this.padDigits(this.decimalToInteger(sumSSO_amount), 12) +
      this.padDigits(this.decimalToInteger(sumSSO_amount), 12) +
      "\r\n";

    const element = document.createElement("a");
    const file = new Blob([text_head + text_body], {
      type: "text/plain;charset=utf-8",
    });
    // ct4600001281-000000-001-072562-003

    element.href = URL.createObjectURL(file);
    element.setAttribute("target", "_blank");
    element.download =
      "ct" +
      doc.account_no +
      "-" +
      doc.company_branch +
      "-" +
      doc.periodic_month +
      doc.periodic_year +
      ".txt";
    document.body.appendChild(element);
    element.click();
  };

  renderFooter() {
    let { data } = this.state;
    let sum_wage = 0;
    let sum_sso_amount = 0;
    let sum_tax = 0;
    data.forEach(function (item, index) {
      if (item.isCheck) {
        let wage = item.wage;
        if (wage === "" || wage === null || wage === undefined || isNaN(wage))
          wage = 0;
        let sso_amount = item.sso_amount;
        if (
          sso_amount === "" ||
          sso_amount === null ||
          sso_amount === undefined ||
          isNaN(sso_amount)
        )
          sso_amount = 0;
        let tax = item.tax;
        if (tax === "" || tax === null || tax === undefined || isNaN(tax))
          tax = 0;
        sum_wage += wage * 1;
        sum_sso_amount += sso_amount * 1;
        sum_tax += tax * 1;
      }
    });
    return (
      <tr>
        <th colSpan={6}></th>
        <th colSpan={2} className="text-right">
          รวมค่าจ้าง {this.getNumberFormat(sum_wage)}
        </th>
        <th colSpan={2} className="text-right">
          รวมเงินสมทบ {this.getNumberFormat(sum_sso_amount)}
        </th>
        <th className="text-right">รวมภาษี {this.getNumberFormat(sum_tax)}</th>
        <th colSpan={2}></th>
      </tr>
    );
  }

  renderRowData() {
    let { data } = this.state;
    if (data.length === 0) {
      return (
        <tr>
          <td colSpan={13}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <Checkbox
                onChange={this.onCheckChange.bind(this, !item.isCheck, index)}
                checked={item.isCheck}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
              ></Checkbox>
            </td>
            <td className="text-left" style={{ verticalAlign: "middle" }}>
              {item.employee_id}
            </td>
            <td className="text-left" style={{ verticalAlign: "middle" }}>
              {item.title}
            </td>
            <td className="text-left" style={{ verticalAlign: "middle" }}>
              {item.first_name + item.last_name}
            </td>
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {this.getNumberFormat(item.salary)}
            </td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              {item.wage_type}
            </td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <FormControl
                className="input-gen-doc text-center"
                value={item.actual_work ? item.actual_work : ""}
                onChange={this.onTextChange.bind(this, "actual_work", index)}
              />
            </td>
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              <FormControl
                className="input-gen-doc text-right"
                value={item.wage ? item.wage : ""}
                onChange={this.onTextChange.bind(this, "wage", index)}
              />
            </td>
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {this.getNumberFormat(item.wage_other)}
            </td>
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {this.getNumberFormat(item.sso_amount)}
            </td>
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {this.getNumberFormat(item.tax)}
            </td>
            <td className="text-right" style={{ verticalAlign: "middle" }}>
              {this.getNumberFormat(item.withdraw)}
            </td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              {item.employee_tax_no}
            </td>
          </tr>
        );
      });
    }
  }

  renderTable() {
    return (
      <div className="table table-responsive">
        <table
          className="table table-hover table-bordered-solid"
          style={{ minWidth: "1800px" }}
        >
          <thead>
            <tr>
              <th className="text-center" style={{ width: "50px" }}>
                คำนวณ
              </th>
              <th className="text-center" style={{ width: "110px" }}>
                รหัส
              </th>
              <th className="text-center" style={{ width: "90px" }}>
                คำนำหน้า
              </th>
              <th className="text-center" style={{ width: "150px" }}>
                ชื่อ-สกุล
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                แก้ฐานค่าจ้าง
              </th>
              <th className="text-center" style={{ width: "90px" }}>
                แก้ประเภท
              </th>
              <th className="text-center" style={{ width: "90px" }}>
                เวลาทำงาน
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                ค่าจ้างสุทธิ
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                รายได้อื่น
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                เงินสมทบ
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                ภาษี
              </th>
              <th className="text-center" style={{ width: "100px" }}>
                เงินหักอื่นๆ
              </th>
              <th className="text-center" style={{ width: "130px" }}>
                บัตรประชาชน
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRowData()}</tbody>
          <tfoot>{this.renderFooter()}</tfoot>
        </table>
      </div>
    );
  }

  renderToolbar() {
    let { doc, data, sumSSO_amount } = this.state;
    let dataCount = data.reduce((sum, item, index) => {
      if (item.isCheck) {
        sum += 1;
      }

      return sum;
    }, 0);

    return (
      <Row>
        <Col md={6}>
          <Form horizontal>
            <FormGroup>
              <Col sm={2}>งวด</Col>
              <Col sm={4}>
                <div className="search-record" style={{ display: "flex" }}>
                  <div style={{ width: "80px", display: "inline-block" }}>
                    <Select
                      value={doc.periodic_year}
                      options={this.getYearOptions()}
                      onChange={this.onPeriodicChange.bind(
                        this,
                        "periodic_year"
                      )}
                      clearable={false}
                    />
                  </div>
                  <div style={{ width: "120px", display: "inline-block" }}>
                    <Select
                      clearable={false}
                      value={doc.periodic_month}
                      options={this.getMonthOptions()}
                      onChange={this.onPeriodicChange.bind(
                        this,
                        "periodic_month"
                      )}
                    />
                  </div>
                  <Button onClick={() => {}}>
                    <FontAwesome name="search" />
                  </Button>
                </div>
              </Col>
              <Col sm={2}>
                <Button bsStyle="primary" onClick={this.onEmpOpen.bind(this)}>
                  <FontAwesome name="user" /> เลือกพนักงาน
                </Button>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2}>เลขที่บัญชี</Col>
              <Col sm={4}>
                <FormControl
                  onChange={this.onFormChange.bind(this, "account_no")}
                  placeholder="เลขที่บัญชี"
                  value={doc.account_no}
                />
              </Col>
              <Col sm={4}>
                <FormControl
                  onChange={this.onFormChange.bind(this, "company_name")}
                  placeholder=""
                  value={doc.company_name}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2}>สาขา</Col>
              <Col sm={4}>
                <FormControl
                  onChange={this.onFormChange.bind(this, "company_branch")}
                  placeholder="สาขา"
                  value={doc.company_branch}
                />
              </Col>
              <Col sm={2}>จำนวนคน</Col>
              <Col sm={2}>
                <FormControl
                  className="text-center"
                  onChange={() => {}}
                  placeholder="จำนวนคน"
                  value={dataCount}
                />
              </Col>
            </FormGroup>
          </Form>
        </Col>
        <Col md={6}>
          <Form horizontal>
            <FormGroup>
              <Col sm={3}>อัตราค่าจ้างต่ำสุด</Col>
              <Col sm={2}>
                <FormControl
                  style={{ width: "100px" }}
                  className="text-right"
                  onChange={() => {}}
                  placeholder=""
                  value={doc.min_sso_wage}
                />
              </Col>
              <Col sm={3}>วันที่ชำระเงิน</Col>
              <Col sm={3}>
                <DatePicker
                  showIcon={true}
                  showFooter={true}
                  popPlacement="bottom"
                  buddhistEra
                  value={doc.payment_date}
                  onChange={this.onPaymentDateChange.bind(this)}
                  maxWidth={"100%"}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={3}>อัตราค่าจ้างสูงสุด</Col>
              <Col sm={2}>
                <FormControl
                  style={{ width: "100px" }}
                  className="text-right"
                  onChange={() => {}}
                  placeholder=""
                  value={doc.max_sso_wage}
                />
              </Col>
              <Col sm={3}>สมทบผู้ประกันตน</Col>
              <Col sm={2}>
                <FormControl
                  style={{ width: "100px" }}
                  className="text-right"
                  onChange={() => {}}
                  placeholder=""
                  value={sumSSO_amount}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={3}>อัตราเงินสมทบ</Col>
              <Col sm={2}>
                <FormControl
                  style={{ width: "100px" }}
                  className="text-right"
                  onChange={this.onFormChange.bind(this, "sso_ratio")}
                  placeholder=""
                  value={doc.sso_ratio}
                />
              </Col>
              <Col sm={3}>สมทบนายจ้าง</Col>
              <Col sm={2}>
                <FormControl
                  style={{ width: "100px" }}
                  className="text-right"
                  onChange={() => {}}
                  placeholder=""
                  value={sumSSO_amount}
                />
              </Col>
              <Col sm={6}>
                <Button
                  bsStyle="success"
                  onClick={this.downloadTxtFile.bind(this, dataCount)}
                >
                  <FontAwesome name="upload" /> ส่ง Text File
                </Button>
                &nbsp;
                <Button bsStyle="primary" onClick={() => {}}>
                  <FontAwesome name="save" /> บันทึก
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    );
  }

  renderEmpModal() {
    let { showEmp, emp_select, branchSelect, departmentSelect } = this.state;
    return (
      <Modal bsSize="lg" show={showEmp} onHide={this.onEmpHide.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>เลือกพนักงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex" }}>
            <div style={{ marginRight: 20 }}>
              <div
                style={{ fontWeight: "bold", fontSize: 20, marginBottom: 10 }}
              >
                สถานะการทำงาน
              </div>
              {this.onLoadEmStatusOptions().map((item, index) => {
                return (
                  <div key={index} style={{ paddingLeft: 10 }}>
                    <Checkbox
                      onChange={this.onEmpCheck.bind(this, item.value)}
                      checked={emp_select.indexOf(item.value) !== -1}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"
                      label={" " + item.label}
                    ></Checkbox>
                  </div>
                );
              })}
            </div>
            <div style={{ marginRight: 20 }}>
              <div
                style={{ fontWeight: "bold", fontSize: 20, marginBottom: 10 }}
              >
                แผนก
              </div>
              {this.state.branchList.map((item) => (
                <div style={{ paddingLeft: 10 }}>
                  <Checkbox
                    onChange={this.onBranchCheck.bind(this, item)}
                    checked={branchSelect.indexOf(item) !== -1}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={` ${item}`}
                  ></Checkbox>
                </div>
              ))}
            </div>
            <div>
              <div
                style={{ fontWeight: "bold", fontSize: 20, marginBottom: 10 }}
              >
                สังกัดบริษัท
              </div>
              {this.state.departmentList.map((item) => (
                <div style={{ paddingLeft: 10 }}>
                  <Checkbox
                    onChange={this.onDepartmentCheck.bind(this, item)}
                    checked={departmentSelect.indexOf(item) !== -1}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={` ${item}`}
                  ></Checkbox>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.onEmpSelect.bind(this)}>
            <FontAwesome name="save" />
            &nbsp;เลือกรายการ
          </Button>
          <Button onClick={this.onEmpHide.bind(this)}>
            <FontAwesome name="close" />
            &nbsp;ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    let { loading } = this.state;
    return (
      <div>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>ตารางเงินสมทบ</Box.Title>
          </Box.Header>
          <Box.Body>
            {this.renderToolbar()}
            {this.renderTable()}
          </Box.Body>
        </Box>
        {this.renderEmpModal()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }
}

ReportSSOPage.defaultProps = {};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
});
export default connect(
  (state) => ({ messages: state.message.view.hr.sso.ReportSSOPage }),
  null,
  null,
  { withRef: true },
  mapSizesToProps
)(ReportSSOPage);



// WEBPACK FOOTER //
// ./src/view/hr/sso/ReportSSOPage.js